<template>
  <div>
    <div class="w3-container">
      <div class="headerGridCMS w3-hide-print">
        <div>
          <header>
            <h2>Site Setup</h2>
          </header>
        </div>
        <div>
          <button class='w3-button w3-right w3-small vmiddle' :class="saving || saved ? 'w3-dark-teal' : 'w3-teal'" :disabled="saving || saved" @click="saveContent()"><span v-if="!saved">Save Changes</span><span v-if="saved">Changes Saved</span></button>
        </div>
      </div>

      <div class="pageMenuGrid">
        <div class="hide-scroll w3-light-grey outline">
          <div class="subNavMenu">
            <div :class="view === 'general' ? 'w3-teal' : ''" @click="view = 'general'">General</div>
            <div :class="view === 'header' ? 'w3-teal' : ''" @click="view = 'header'">Header</div>
            <div :class="view === 'footer' ? 'w3-teal' : ''" @click="view = 'footer'">Footer</div>
            <div :class="view === 'nav' ? 'w3-teal' : ''" @click="view = 'nav'">Navigation</div>
            <div :class="view === 'content' ? 'w3-teal' : ''" @click="view = 'content'">Content</div>
            <div :class="view === 'pages' ? 'w3-teal' : ''" @click="view = 'pages'">Pages</div>
          </div>
        </div>
        <div>
          <!-- General Config -->
          <div v-if="view === 'general'">
            <cmsSettingsGeneral></cmsSettingsGeneral>
          </div>
          <!-- Header Config -->
          <div v-if="view === 'header'">
            <cmsSettingsHeader></cmsSettingsHeader>
          </div>
          <!-- Footer Config -->
          <div v-if="view === 'footer'">
            <div class="inputCard">
              <header>Footer</header>
              <div class="content">
                <div class="cardRow w3-padding-8">
                  <label>Footer Type</label>
                  <div class="w3-right-align">
                    <select class="w3-select w3-border" v-model="state.siteData.footer.type">
                      <option value="classic">Classic</option>
                      <option value="modern">Modern</option>
                    </select>
                  </div>
                </div>
                <div class="cardRow w3-padding-8">
                  <label>Footer Color</label>
                  <div class="w3-right-align">
                    <input class="w3-input w3-border" v-model="state.siteData.footer.color" placeholder="#212529" />
                  </div>
                </div>
                <div class="cardRow w3-padding-8">
                  <label>Footer Text Color</label>
                  <div class="w3-right-align">
                    <input class="w3-input w3-border" v-model="state.siteData.footer.textColor" placeholder="#777777" />
                  </div>
                </div>
                <div class="cardRow w3-padding-8">
                  <label>Footer About Enabled</label>
                  <div class="w3-right-align">
                    <label class="switch">
                      <input type="checkbox" v-model="state.siteData.footer.about.enabled">
                      <span class="slider"></span>
                    </label>
                  </div>
                </div>
                <div class="input-row w3-padding-8">
                  <label>Footer About Text</label>
                  <tinymce-editor api-key="t5p4kok2r7znye5exinvmcmpazco8x8rd3hoapujd41dps8c" :init="state.tinymceInit" v-model="state.siteData.footer.about.text"></tinymce-editor>
                </div>
              </div>
            </div>
          </div>
          <!-- Nav Config -->
          <div v-if="view === 'nav'">
            <div class="inputCard">
              <header>Navigation</header>
              <div class="content">
                <div class="cardRow w3-padding-8">
                  <label>Nav Type</label>
                  <div class="w3-right-align">
                    <select class="w3-select w3-border" v-model="state.siteData.nav.type">
                      <option value="pills">Pills</option>
                      <option value="stripe">Stripes</option>
                      <option value="hover-slide">Hover Slide</option>
                      <option value="vertical-columns">Vertical</option>
                    </select>
                  </div>
                </div>
                <div class="cardRow w3-padding-8">
                  <label>Enable Home Link</label>
                  <div class="w3-right-align">
                    <label class="switch">
                      <input type="checkbox" v-model="state.siteData.header.homeEnabled">
                      <span class="slider"></span>
                    </label>
                  </div>
                </div>
                <div class="cardRow w3-padding-8">
                  <label>Align Left?</label>
                  <div class="w3-right-align">
                    <label class="switch">
                      <input type="checkbox" v-model="state.siteData.nav.left">
                      <span class="slider"></span>
                    </label>
                  </div>
                </div>
                <div class="cardRow w3-padding-8" v-if="state.siteData.nav.type === 'pills'">
                  <label>Square?</label>
                  <div class="w3-right-align">
                    <label class="switch">
                      <input type="checkbox" v-model="state.siteData.nav.square">
                      <span class="slider"></span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Content -->
          <div v-if="view === 'content'">
            <cmsSettingsContent></cmsSettingsContent>
          </div>

          <!-- Pages -->
          <div v-if="view === 'pages'">
            <div class="input-row-2">
              <div>
                <div class="inputCard">
                  <header>Standard Pages</header>
                  <div class="content">
                    <div class="cardRow w3-padding-8">
                      <label class="w3-label">Services</label>
                      <div class="w3-right-align">
                        <label class="switch">
                          <input type="checkbox" v-model="sitePages.services">
                          <span class="slider"></span>
                        </label>
                      </div>
                    </div>
                    <div class="cardRow w3-padding-8">
                      <label class="w3-label">About</label>
                      <div class="w3-right-align">
                        <label class="switch">
                          <input type="checkbox" v-model="sitePages.about">
                          <span class="slider"></span>
                        </label>
                      </div>
                    </div>
                    <div class="cardRow w3-padding-8">
                      <label class="w3-label">Team</label>
                      <div class="w3-right-align">
                        <label class="switch">
                          <input type="checkbox" v-model="sitePages.team">
                          <span class="slider"></span>
                        </label>
                      </div>
                    </div>
                    <div class="cardRow w3-padding-8">
                      <label class="w3-label">News</label>
                      <div class="w3-right-align">
                        <label class="switch">
                          <input type="checkbox" v-model="sitePages.news">
                          <span class="slider"></span>
                        </label>
                      </div>
                    </div>
                    <div class="cardRow w3-padding-8">
                      <label class="w3-label">Portfolio</label>
                      <div class="w3-right-align">
                        <label class="switch">
                          <input type="checkbox" v-model="sitePages.portfolio">
                          <span class="slider"></span>
                        </label>
                      </div>
                    </div>
                    <div class="cardRow w3-padding-8">
                      <label class="w3-label">Shop</label>
                      <div class="w3-right-align">
                        <label class="switch">
                          <input type="checkbox" v-model="sitePages.shop">
                          <span class="slider"></span>
                        </label>
                      </div>
                    </div>
                    <div class="cardRow w3-padding-8">
                      <label class="w3-label">Repairs</label>
                      <div class="w3-right-align">
                        <label class="switch">
                          <input type="checkbox" v-model="state.siteData.pages.repairs.enabled">
                          <span class="slider"></span>
                        </label>
                      </div>
                    </div>
                    <div class="cardRow w3-padding-8">
                      <label class="w3-label">Contact</label>
                      <div class="w3-right-align">
                        <label class="switch">
                          <input type="checkbox" v-model="sitePages.contact">
                          <span class="slider"></span>
                        </label>
                      </div>
                    </div>
                    <div class="cardRow w3-padding-8">
                      <label class="w3-label">Sitemap</label>
                      <div class="w3-right-align">
                        <label class="switch">
                          <input type="checkbox" v-model="sitePages.sitemap">
                          <span class="slider"></span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div class="inputCard">
                  <header>Custom Pages</header>
                  <div class="content">
                    <div class="cardRow w3-padding-8">
                      <label>Create New Page Link</label>
                      <div class="w3-right-align">
                        <router-link to="/cms/custom-pages-detail" class="w3-button w3-teal w3-small w3-right vmiddle">
                          <i class="fas fa-plus" style="margin-right:8px;"></i>New Page
                        </router-link>
                      </div>
                    </div>
                    <div class="customPagesContentGrid w3-padding-8" v-for="(customPage, index) in state.siteData.pages.custom.items" :key="index">
                      <div class="customPagesName w3-padding-8"><b>{{customPage.name}}</b></div>
                      <div class="customPagesLink w3-padding-8">{{customPage.link}}</div>
                      <div class="buttons">
                        <router-link tag="button" :to="'/cms/custom-pages-detail/' + customPage.name" class="w3-button w3-small w3-teal">Edit</router-link>
                        <button class="w3-button w3-small w3-red" @click="deleteCustomPage(customPage.name)">Delete</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      <div class="w3-right-align w3-margin-top w3-margin-bottom">
        <button class='w3-button' :class="saving || saved ? 'w3-dark-teal' : 'w3-teal'" :disabled="saving || saved" @click="saveContent()"><span v-if="!saved">Save Changes</span><span v-if="saved">Changes Saved</span></button>
      </div>
    </div>
  </div>
</template>

<script>
import cmsSettingsGeneral from '@/components/cms/cmsSettingsGeneral.vue'
import cmsSettingsHeader from '@/components/cms/cmsSettingsHeader.vue'
import cmsSettingsContent from '@/components/cms/cmsSettingsContent.vue'
import Editor from '@tinymce/tinymce-vue'
// import cmsSettingsPages from '@/components/cms/cmsSettingsPages.vue'
var dataStore = require('../../dataStore').default

export default {
  name: 'cmsSettings',
  data() {
    return {
      state: dataStore.state,
      sitePages: {
        services: false,
        about: false,
        team: false,
        news: false,
        portfolio: false,
        shop: false,
        contact: false,
        sitemap: false
      },
      view: 'general',
      saving: false,
      saved: false
    }
  },
  components: {
    cmsSettingsGeneral,
    cmsSettingsHeader,
    cmsSettingsContent,
    'tinymce-editor': Editor
    // cmsSettingsPages
  },
  created() {
    for (let page in this.sitePages) {
      for (let setPage of this.state.siteData.site_pages) {
        if (page === setPage) {
          this.sitePages[page] = true
        }
      }
    }
    if (this.$route.params.page) {
      this.view = this.$route.params.page
    }
  },
  methods: {
    saveContent() {
      for (let page in this.sitePages) {
        let index = 0
        let found = false
        for (let setPage of this.state.siteData.site_pages) {
          if (page === setPage) {
            found = true
            break
          }
          index++
        }
        if (this.sitePages[page]) {
          if (!found) {
            this.state.siteData.site_pages.push(page)
          }
        } else {
          if (found) {
            this.state.siteData.site_pages.splice(index, 1)
          }
        }
      }
      this.saving = true
      dataStore.saveSiteData().then((res) => {
        this.saving = false
        if (res === 'success') {
          this.saved = true
          setTimeout(() => {
            this.saved = false
          }, 2000)
        }
      })
    },
    deleteCustomPage(name) {
      let itemIndex = this.state.siteData.pages.custom.items.findIndex(savedCustomPage => savedCustomPage.name === name)
      if (itemIndex > -1) {
        if (confirm('Really DELETE ' + this.state.siteData.pages.custom.items[itemIndex].name + ' page?')) {
          this.state.siteData.pages.custom.items.splice(itemIndex, 1)
          this.saveContent()
        }
      }
    }
  }
}
</script>

<style scoped>
.hide-scroll {overflow-y: hidden; margin-bottom: calc(-.1 * var(--gutter));}

.subNavMenu {padding: 0; display: grid; grid-gap: 0; grid-template-columns: 1fr;}
.subNavMenu > div {padding:8px 16px;}

@media screen and (max-width:600px) {
  .subNavMenu {grid-template-columns: repeat(6, 1fr);}
}
</style>



// WEBPACK FOOTER //
// src/components/cms/cmsSettings.vue